/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Stratus GA4GH API
 * Stratus GA4GH APIs 
 *
 * OpenAPI spec version: v1
 * Contact: ILMN-Role-EIBU-Platform-PipelineServices@illumina.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as url from "url";
import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "https://dev.stratus.illumina.com".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *  
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 * 
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 * 
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AccessURL
 */
export interface AccessURL {
    /**
     * An optional list of headers to include in the HTTP request to `url`. These headers can be used to provide auth tokens required to fetch the object bytes.
     * @type {Array<string>}
     * @memberof AccessURL
     */
    headers?: Array<string>;
    /**
     * A fully resolvable URL that can be used to fetch the actual object bytes.
     * @type {string}
     * @memberof AccessURL
     */
    url: string;
}

/**
 * 
 * @export
 * @interface Bundle
 */
export interface Bundle {
    /**
     * A list of strings that can be used to find other metadata about this Data Bundle from external metadata sources. These aliases can be used to represent the Data Bundle's secondary accession numbers or external GUIDs.
     * @type {Array<string>}
     * @memberof Bundle
     */
    aliases?: Array<string>;
    /**
     * The checksum of the Data Bundle. At least one checksum must be provided.  The Data Bundle checksum is computed over a sorted concatenation of all the checksums (names not included) within the top-level 'contents' of the Bundle (not recursive). The list of Data Object or Bundle checksums are sorted alphabetically (hex-code) before concatenation and a further checksum is performed on the concatenated checksum value. Example below: Data Ojects:   md5(DO1) = 72794b6d30bc86d92e40a1aa65c880b8   md5(DO2) = 5e089d29a18954e68a78ee6a3c6edabd Data Bundle: DB1 = md5( concat( sort( md5(DO1), md5(DO2) ) ) )     = md5( concat( sort( 72794b6d30bc86d92e40a1aa65c880b8, 5e089d29a18954e68a78ee6a3c6edabd ) ) )     = md5( concat( 5e089d29a18954e68a78ee6a3c6edabd, 72794b6d30bc86d92e40a1aa65c880b8 ) )     = md5( 5e089d29a18954e68a78ee6a3c6edabd72794b6d30bc86d92e40a1aa65c880b8 )     = f7a29a0422e7d870b10839ad6c985079
     * @type {Array<Checksum>}
     * @memberof Bundle
     */
    checksums: Array<Checksum>;
    /**
     * The list of Data Objects and Data Bundles contained by this Data Bundle.
     * @type {Array<BundleObject>}
     * @memberof Bundle
     */
    contents: Array<BundleObject>;
    /**
     * Timestamp of Bundle creation in RFC3339.
     * @type {Date}
     * @memberof Bundle
     */
    created: Date;
    /**
     * A human readable description of the Data Bundle.
     * @type {string}
     * @memberof Bundle
     */
    description?: string;
    /**
     * An identifier unique to this Data Bundle.
     * @type {string}
     * @memberof Bundle
     */
    id: string;
    /**
     * A string that can be used to name a Data Bundle.
     * @type {string}
     * @memberof Bundle
     */
    name?: string;
    /**
     * The cumulative size, in bytes, of all Data Objects and Bundles listed in the `contents` field.
     * @type {string}
     * @memberof Bundle
     */
    size: string;
    /**
     * Timestamp of Bundle update in RFC3339, identical to create timestamp in systems that do not support updates.
     * @type {Date}
     * @memberof Bundle
     */
    updated?: Date;
    /**
     * A string representing a version. (Some systems may use checksum, a RFC3339 timestamp, or an incrementing version number.)
     * @type {string}
     * @memberof Bundle
     */
    version?: string;
}

/**
 * 
 * @export
 * @interface BundleObject
 */
export interface BundleObject {
    /**
     * A list of full DRS identifier URI paths that may be used obtain the Data Object or Data Bundle. These URIs may be external to this DRS instance.
     * @type {Array<string>}
     * @memberof BundleObject
     */
    drs_uri?: Array<string>;
    /**
     * A DRS identifier of a Data Object or a nested Data Bundle.
     * @type {string}
     * @memberof BundleObject
     */
    id: string;
    /**
     * A name declared by the Bundle author that must be used when materialising the associated data object, overriding any name directly associated with the object itself. This string MUST NOT contain any slashes.
     * @type {string}
     * @memberof BundleObject
     */
    name: string;
    /**
     * The type of content being referenced. BundleObject of type bundle will need to be recursed further.
     * @type {string}
     * @memberof BundleObject
     */
    type: BundleObject.TypeEnum;
}

/**
 * @export
 * @namespace BundleObject
 */
export namespace BundleObject {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        Object = <any> 'object',
        Bundle = <any> 'bundle'
    }
}

/**
 * 
 * @export
 * @interface Checksum
 */
export interface Checksum {
    /**
     * The hex-string encoded checksum for the data
     * @type {string}
     * @memberof Checksum
     */
    checksum: string;
    /**
     * The digest method used to create the checksum. If left unspecified md5 will be assumed.  possible values: md5               # most blob stores provide a checksum using this etag              # multipart uploads to blob stores sha256 sha512
     * @type {string}
     * @memberof Checksum
     */
    type?: string;
}

/**
 * A message that allows one to describe default parameters for a workflow engine.
 * @export
 * @interface DefaultWorkflowEngineParameter
 */
export interface DefaultWorkflowEngineParameter {
    /**
     * The stringified version of the default parameter. e.g. \"2.45\".
     * @type {string}
     * @memberof DefaultWorkflowEngineParameter
     */
    default_value?: string;
    /**
     * The name of the parameter
     * @type {string}
     * @memberof DefaultWorkflowEngineParameter
     */
    name?: string;
    /**
     * Describes the type of the parameter, e.g. float.
     * @type {string}
     * @memberof DefaultWorkflowEngineParameter
     */
    type?: string;
}

/**
 * An object that can optionally include information about the error.
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * A detailed error message.
     * @type {string}
     * @memberof ErrorResponse
     */
    msg?: string;
    /**
     * The integer representing the HTTP status code (e.g. 200, 404).
     * @type {number}
     * @memberof ErrorResponse
     */
    status_code?: number;
}

/**
 * 
 * @export
 * @interface InputStream
 */
export interface InputStream {
}

/**
 * Log and other info
 * @export
 * @interface Log
 */
export interface Log {
    /**
     * The command line that was executed
     * @type {Array<string>}
     * @memberof Log
     */
    cmd?: Array<string>;
    /**
     * When the command stopped executing (completed, failed, or cancelled), in ISO 8601 format \"%Y-%m-%dT%H:%M:%SZ\"
     * @type {Date}
     * @memberof Log
     */
    end_time?: Date;
    /**
     * Exit code of the program
     * @type {number}
     * @memberof Log
     */
    exit_code?: number;
    /**
     * The task or workflow name
     * @type {string}
     * @memberof Log
     */
    name?: string;
    /**
     * When the command started executing, in ISO 8601 format \"%Y-%m-%dT%H:%M:%SZ\"
     * @type {Date}
     * @memberof Log
     */
    start_time?: Date;
    /**
     * A URL to retrieve standard error logs of the workflow run or task.  This URL may change between status requests, or may not be available until the task or workflow has finished execution.  Should be available using the same credentials used to access the WES endpoint.
     * @type {string}
     * @memberof Log
     */
    stderr?: string;
    /**
     * A URL to retrieve standard output logs of the workflow run or task.  This URL may change between status requests, or may not be available until the task or workflow has finished execution.  Should be available using the same credentials used to access the WES endpoint.
     * @type {string}
     * @memberof Log
     */
    stdout?: string;
}

/**
 * Describes this registry to better allow for mirroring and indexing.
 * @export
 * @interface Metadata
 */
export interface Metadata {
    /**
     * The version of the GA4GH tool-registry API supported by this registry
     * @type {string}
     * @memberof Metadata
     */
    api_version: string;
    /**
     * A country code for the registry (ISO 3166-1 alpha-3)
     * @type {string}
     * @memberof Metadata
     */
    country?: string;
    /**
     * A friendly name that can be used in addition to the hostname to describe a registry
     * @type {string}
     * @memberof Metadata
     */
    friendly_name?: string;
    /**
     * The version of this registry
     * @type {string}
     * @memberof Metadata
     */
    version: string;
}

/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {number}
     * @memberof ModelError
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    message?: string;
}

/**
 * 
 * @export
 * @interface ModelFile
 */
export interface ModelFile {
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    absolute?: boolean;
    /**
     * 
     * @type {any}
     * @memberof ModelFile
     */
    absoluteFile?: any;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    absolutePath?: string;
    /**
     * 
     * @type {any}
     * @memberof ModelFile
     */
    canonicalFile?: any;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    canonicalPath?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    directory?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    executable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    file?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    freeSpace?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    hidden?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    lastModified?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    parent?: string;
    /**
     * 
     * @type {any}
     * @memberof ModelFile
     */
    parentFile?: any;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    readable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    totalSpace?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    usableSpace?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    writable?: boolean;
}

/**
 * 
 * @export
 * @interface Resource
 */
export interface Resource {
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    description?: string;
    /**
     * 
     * @type {any}
     * @memberof Resource
     */
    file?: any;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    filename?: string;
    /**
     * 
     * @type {InputStream}
     * @memberof Resource
     */
    inputStream?: InputStream;
    /**
     * 
     * @type {boolean}
     * @memberof Resource
     */
    open?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Resource
     */
    readable?: boolean;
    /**
     * 
     * @type {URI}
     * @memberof Resource
     */
    uri?: URI;
    /**
     * 
     * @type {URL}
     * @memberof Resource
     */
    url?: URL;
}

/**
 * 
 * @export
 * @interface RunId
 */
export interface RunId {
    /**
     * workflow run ID
     * @type {string}
     * @memberof RunId
     */
    run_id?: string;
}

/**
 * The service will return a RunListResponse when receiving a successful RunListRequest.
 * @export
 * @interface RunListResponse
 */
export interface RunListResponse {
    /**
     * A token which may be supplied as `page_token` in workflow run list request to get the next page of results.  An empty string indicates there are no more items to return.
     * @type {string}
     * @memberof RunListResponse
     */
    next_page_token?: string;
    /**
     * A list of workflow runs that the service has executed or is executing. The list is filtered to only include runs that the caller has permission to see.
     * @type {Array<RunStatus>}
     * @memberof RunListResponse
     */
    runs?: Array<RunStatus>;
}

/**
 * 
 * @export
 * @interface RunLog
 */
export interface RunLog {
    /**
     * The outputs from the workflow run.
     * @type {any}
     * @memberof RunLog
     */
    outputs?: any;
    /**
     * The original request message used to initiate this execution.
     * @type {RunRequest}
     * @memberof RunLog
     */
    request?: RunRequest;
    /**
     * workflow run ID
     * @type {string}
     * @memberof RunLog
     */
    run_id?: string;
    /**
     * The logs, and other key info like timing and exit code, for the overall run of this workflow.
     * @type {Log}
     * @memberof RunLog
     */
    run_log?: Log;
    /**
     * The state of the run e.g. RUNNING (see State)
     * @type {string}
     * @memberof RunLog
     */
    state?: RunLog.StateEnum;
    /**
     * The logs, and other key info like timing and exit code, for each step in the workflow run.
     * @type {Array<Log>}
     * @memberof RunLog
     */
    task_logs?: Array<Log>;
}

/**
 * @export
 * @namespace RunLog
 */
export namespace RunLog {
    /**
     * @export
     * @enum {string}
     */
    export enum StateEnum {
        UNKNOWN = <any> 'UNKNOWN',
        QUEUED = <any> 'QUEUED',
        INITIALIZING = <any> 'INITIALIZING',
        RUNNING = <any> 'RUNNING',
        PAUSED = <any> 'PAUSED',
        COMPLETE = <any> 'COMPLETE',
        EXECUTORERROR = <any> 'EXECUTOR_ERROR',
        SYSTEMERROR = <any> 'SYSTEM_ERROR',
        CANCELED = <any> 'CANCELED',
        CANCELING = <any> 'CANCELING'
    }
}

/**
 * To execute a workflow, send a run request including all the details needed to begin downloading and executing a given workflow.
 * @export
 * @interface RunRequest
 */
export interface RunRequest {
    /**
     * OPTIONAL A key-value map of arbitrary metadata outside the scope of `workflow_params` but useful to track with this run request
     * @type {{ [key: string]: string; }}
     * @memberof RunRequest
     */
    tags?: { [key: string]: string; };
    /**
     * OPTIONAL Additional parameters can be sent to the workflow engine using this field. Default values for these parameters can be obtained using the ServiceInfo endpoint.
     * @type {{ [key: string]: string; }}
     * @memberof RunRequest
     */
    workflow_engine_parameters?: { [key: string]: string; };
    /**
     * REQUIRED The workflow run parameterizations (JSON encoded), including input and output file locations
     * @type {any}
     * @memberof RunRequest
     */
    workflow_params?: any;
    /**
     * REQUIRED The workflow descriptor type, must be \"CWL\" or \"WDL\" currently (or another alternative supported by this WES instance)
     * @type {string}
     * @memberof RunRequest
     */
    workflow_type?: string;
    /**
     * REQUIRED The workflow descriptor type version, must be one supported by this WES instance
     * @type {string}
     * @memberof RunRequest
     */
    workflow_type_version?: string;
    /**
     * REQUIRED The workflow CWL or WDL document. When `workflow_attachments` is used to attach files, the `workflow_url` may be a relative path to one of the attachments.
     * @type {string}
     * @memberof RunRequest
     */
    workflow_url?: string;
}

/**
 * Small description of a workflow run, returned by server during listing
 * @export
 * @interface RunStatus
 */
export interface RunStatus {
    /**
     * 
     * @type {string}
     * @memberof RunStatus
     */
    run_id: string;
    /**
     * 
     * @type {string}
     * @memberof RunStatus
     */
    state?: RunStatus.StateEnum;
}

/**
 * @export
 * @namespace RunStatus
 */
export namespace RunStatus {
    /**
     * @export
     * @enum {string}
     */
    export enum StateEnum {
        UNKNOWN = <any> 'UNKNOWN',
        QUEUED = <any> 'QUEUED',
        INITIALIZING = <any> 'INITIALIZING',
        RUNNING = <any> 'RUNNING',
        PAUSED = <any> 'PAUSED',
        COMPLETE = <any> 'COMPLETE',
        EXECUTORERROR = <any> 'EXECUTOR_ERROR',
        SYSTEMERROR = <any> 'SYSTEM_ERROR',
        CANCELED = <any> 'CANCELED',
        CANCELING = <any> 'CANCELING'
    }
}

/**
 * A message containing useful information about the running service, including supported versions and default settings.
 * @export
 * @interface ServiceInfo
 */
export interface ServiceInfo {
    /**
     * A web page URL with human-readable instructions on how to get an authorization token for use with a specific WES endpoint.
     * @type {string}
     * @memberof ServiceInfo
     */
    auth_instructions_url?: string;
    /**
     * An email address URL (mailto:) or web page URL with contact information for the operator of a specific WES endpoint.  Users of the endpoint should use this to report problems or security vulnerabilities.
     * @type {string}
     * @memberof ServiceInfo
     */
    contact_info_url?: string;
    /**
     * Each workflow engine can present additional parameters that can be sent to the workflow engine. This message will list the default values, and their types for each workflow engine.
     * @type {Array<DefaultWorkflowEngineParameter>}
     * @memberof ServiceInfo
     */
    default_workflow_engine_parameters?: Array<DefaultWorkflowEngineParameter>;
    /**
     * The filesystem protocols supported by this service, currently these may include common protocols using the terms 'http', 'https', 'sftp', 's3', 'gs', 'file', or 'synapse', but others are possible and the terms beyond these core protocols are currently not fixed. This section reports those protocols (either common or not) supported by this WES service.
     * @type {Array<string>}
     * @memberof ServiceInfo
     */
    supported_filesystem_protocols?: Array<string>;
    /**
     * The version(s) of the WES schema supported by this service
     * @type {Array<string>}
     * @memberof ServiceInfo
     */
    supported_wes_versions?: Array<string>;
    /**
     * The system statistics, key is the statistic, value is the count of runs in that state. See the State enum for the possible keys.
     * @type {{ [key: string]: number; }}
     * @memberof ServiceInfo
     */
    system_state_counts?: { [key: string]: number; };
    /**
     * A key-value map of arbitrary, extended metadata outside the scope of the above but useful to report back
     * @type {{ [key: string]: string; }}
     * @memberof ServiceInfo
     */
    tags?: { [key: string]: string; };
    /**
     * The engine(s) used by this WES service, key is engine name (e.g. Cromwell) and value is version
     * @type {{ [key: string]: string; }}
     * @memberof ServiceInfo
     */
    workflow_engine_versions?: { [key: string]: string; };
    /**
     * A map with keys as the workflow format type name (currently only CWL and WDL are used although a service may support others) and value is a workflow_type_version object which simply contains an array of one or more version strings
     * @type {{ [key: string]: WorkflowTypeVersion; }}
     * @memberof ServiceInfo
     */
    workflow_type_versions?: { [key: string]: WorkflowTypeVersion; };
}

/**
 * CancelTaskResponse describes a response from the CancelTask endpoint.
 * @export
 * @interface TesCancelTaskResponse
 */
export interface TesCancelTaskResponse {
}

/**
 * CreateTaskResponse describes a response from the CreateTask endpoint.
 * @export
 * @interface TesCreateTaskResponse
 */
export interface TesCreateTaskResponse {
    /**
     * Task identifier assigned by the server.
     * @type {string}
     * @memberof TesCreateTaskResponse
     */
    id?: string;
}

/**
 * Executor describes a command to be executed, and its environment.
 * @export
 * @interface TesExecutor
 */
export interface TesExecutor {
    /**
     * A sequence of program arguments to execute, where the first argument is the program to execute (i.e. argv).
     * @type {Array<string>}
     * @memberof TesExecutor
     */
    command?: Array<string>;
    /**
     * Enviromental variables to set within the container.
     * @type {{ [key: string]: string; }}
     * @memberof TesExecutor
     */
    env?: { [key: string]: string; };
    /**
     * Name of the container image, for example: ubuntu quay.io/aptible/ubuntu gcr.io/my-org/my-image etc...
     * @type {string}
     * @memberof TesExecutor
     */
    image?: string;
    /**
     * Path inside the container to a file where the executor's stderr will be written to. Must be an absolute path.
     * @type {string}
     * @memberof TesExecutor
     */
    stderr?: string;
    /**
     * Path inside the container to a file which will be piped to the executor's stdin. Must be an absolute path.
     * @type {string}
     * @memberof TesExecutor
     */
    stdin?: string;
    /**
     * Path inside the container to a file where the executor's stdout will be written to. Must be an absolute path.
     * @type {string}
     * @memberof TesExecutor
     */
    stdout?: string;
    /**
     * The working directory that the command will be executed in. Defaults to the directory set by the container image.
     * @type {string}
     * @memberof TesExecutor
     */
    workdir?: string;
}

/**
 * ExecutorLog describes logging information related to an Executor.
 * @export
 * @interface TesExecutorLog
 */
export interface TesExecutorLog {
    /**
     * Time the executor ended, in RFC 3339 format.
     * @type {string}
     * @memberof TesExecutorLog
     */
    end_time?: string;
    /**
     * Exit code.
     * @type {number}
     * @memberof TesExecutorLog
     */
    exit_code?: number;
    /**
     * Time the executor started, in RFC 3339 format.
     * @type {string}
     * @memberof TesExecutorLog
     */
    start_time?: string;
    /**
     * Stderr content.  This is meant for convenience. No guarantees are made about the content. Implementations may chose different approaches: only the head, only the tail, a URL reference only, etc.  In order to capture the full stderr users should set Executor.stderr to a container file path, and use Task.outputs to upload that file to permanent storage.
     * @type {string}
     * @memberof TesExecutorLog
     */
    stderr?: string;
    /**
     * Stdout content.  This is meant for convenience. No guarantees are made about the content. Implementations may chose different approaches: only the head, only the tail, a URL reference only, etc.  In order to capture the full stdout users should set Executor.stdout to a container file path, and use Task.outputs to upload that file to permanent storage.
     * @type {string}
     * @memberof TesExecutorLog
     */
    stdout?: string;
}

/**
 * Input describes Task input files.
 * @export
 * @interface TesInput
 */
export interface TesInput {
    /**
     * File content literal.  Implementations should support a minimum of 128 KiB in this field and may define its own maximum. UTF-8 encoded  If content is not empty, \"url\" must be ignored.
     * @type {string}
     * @memberof TesInput
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof TesInput
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TesInput
     */
    name?: string;
    /**
     * Path of the file inside the container. Must be an absolute path.
     * @type {string}
     * @memberof TesInput
     */
    path?: string;
    /**
     * Type of the file, FILE or DIRECTORY
     * @type {string}
     * @memberof TesInput
     */
    type?: TesInput.TypeEnum;
    /**
     * REQUIRED, unless \"content\" is set.  URL in long term storage, for example: s3://my-object-store/file1 gs://my-bucket/file2 file:///path/to/my/file /path/to/my/file etc...
     * @type {string}
     * @memberof TesInput
     */
    url?: string;
}

/**
 * @export
 * @namespace TesInput
 */
export namespace TesInput {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        FILE = <any> 'FILE',
        DIRECTORY = <any> 'DIRECTORY'
    }
}

/**
 * ListTasksResponse describes a response from the ListTasks endpoint.
 * @export
 * @interface TesListTasksResponse
 */
export interface TesListTasksResponse {
    /**
     * Token used to return the next page of results. See TaskListRequest.next_page_token
     * @type {string}
     * @memberof TesListTasksResponse
     */
    next_page_token?: string;
    /**
     * List of tasks.
     * @type {Array<TesTask>}
     * @memberof TesListTasksResponse
     */
    tasks?: Array<TesTask>;
}

/**
 * Output describes Task output files.
 * @export
 * @interface TesOutput
 */
export interface TesOutput {
    /**
     * 
     * @type {string}
     * @memberof TesOutput
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TesOutput
     */
    name?: string;
    /**
     * Path of the file inside the container. Must be an absolute path.
     * @type {string}
     * @memberof TesOutput
     */
    path?: string;
    /**
     * Type of the file, FILE or DIRECTORY
     * @type {string}
     * @memberof TesOutput
     */
    type?: TesOutput.TypeEnum;
    /**
     * URL in long term storage, for example: s3://my-object-store/file1 gs://my-bucket/file2 file:///path/to/my/file /path/to/my/file etc...
     * @type {string}
     * @memberof TesOutput
     */
    url?: string;
}

/**
 * @export
 * @namespace TesOutput
 */
export namespace TesOutput {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        FILE = <any> 'FILE',
        DIRECTORY = <any> 'DIRECTORY'
    }
}

/**
 * OutputFileLog describes a single output file. This describes file details after the task has completed successfully, for logging purposes.
 * @export
 * @interface TesOutputFileLog
 */
export interface TesOutputFileLog {
    /**
     * Path of the file inside the container. Must be an absolute path.
     * @type {string}
     * @memberof TesOutputFileLog
     */
    path?: string;
    /**
     * Size of the file in bytes.
     * @type {string}
     * @memberof TesOutputFileLog
     */
    size_bytes?: string;
    /**
     * URL of the file in storage, e.g. s3://bucket/file.txt
     * @type {string}
     * @memberof TesOutputFileLog
     */
    url?: string;
}

/**
 * Resources describes the resources requested by a task.
 * @export
 * @interface TesResources
 */
export interface TesResources {
    /**
     * Requested number of CPUs
     * @type {number}
     * @memberof TesResources
     */
    cpu_cores?: number;
    /**
     * Requested disk size in gigabytes (GB)
     * @type {number}
     * @memberof TesResources
     */
    disk_gb?: number;
    /**
     * Is the task allowed to run on preemptible compute instances (e.g. AWS Spot)?
     * @type {boolean}
     * @memberof TesResources
     */
    preemptible?: boolean;
    /**
     * Requested RAM required in gigabytes (GB)
     * @type {number}
     * @memberof TesResources
     */
    ram_gb?: number;
    /**
     * Request that the task be run in these compute zones.
     * @type {Array<string>}
     * @memberof TesResources
     */
    zones?: Array<string>;
}

/**
 * ServiceInfo describes information about the service, such as storage details, resource availability, and other documentation.
 * @export
 * @interface TesServiceInfo
 */
export interface TesServiceInfo {
    /**
     * Returns a documentation string, e.g. \"Hey, we're OHSU Comp. Bio!\".
     * @type {string}
     * @memberof TesServiceInfo
     */
    doc?: string;
    /**
     * Returns the name of the service, e.g. \"ohsu-compbio-funnel\".
     * @type {string}
     * @memberof TesServiceInfo
     */
    name?: string;
    /**
     * Lists some, but not necessarily all, storage locations supported by the service.  Must be in a valid URL format. e.g.  file:///path/to/local/funnel-storage s3://ohsu-compbio-funnel/storage etc.
     * @type {Array<string>}
     * @memberof TesServiceInfo
     */
    storage?: Array<string>;
}

/**
 * Task describes an instance of a task.
 * @export
 * @interface TesTask
 */
export interface TesTask {
    /**
     * Date + time the task was created, in RFC 3339 format. This is set by the system, not the client.
     * @type {string}
     * @memberof TesTask
     */
    creation_time?: string;
    /**
     * 
     * @type {string}
     * @memberof TesTask
     */
    description?: string;
    /**
     * A list of executors to be run, sequentially. Execution stops on the first error.
     * @type {Array<TesExecutor>}
     * @memberof TesTask
     */
    executors?: Array<TesExecutor>;
    /**
     * Task identifier assigned by the server.
     * @type {string}
     * @memberof TesTask
     */
    id?: string;
    /**
     * Input files. Inputs will be downloaded and mounted into the executor container.
     * @type {Array<TesInput>}
     * @memberof TesTask
     */
    inputs?: Array<TesInput>;
    /**
     * Task logging information. Normally, this will contain only one entry, but in the case where a task fails and is retried, an entry will be appended to this list.
     * @type {Array<TesTaskLog>}
     * @memberof TesTask
     */
    logs?: Array<TesTaskLog>;
    /**
     * 
     * @type {string}
     * @memberof TesTask
     */
    name?: string;
    /**
     * Output files. Outputs will be uploaded from the executor container to long-term storage.
     * @type {Array<TesOutput>}
     * @memberof TesTask
     */
    outputs?: Array<TesOutput>;
    /**
     * Request that the task be run with these resources.
     * @type {TesResources}
     * @memberof TesTask
     */
    resources?: TesResources;
    /**
     * 
     * @type {string}
     * @memberof TesTask
     */
    state?: TesTask.StateEnum;
    /**
     * A key-value map of arbitrary tags.
     * @type {{ [key: string]: string; }}
     * @memberof TesTask
     */
    tags?: { [key: string]: string; };
    /**
     * Volumes are directories which may be used to share data between Executors. Volumes are initialized as empty directories by the system when the task starts and are mounted at the same path in each Executor.  For example, given a volume defined at \"/vol/A\", executor 1 may write a file to \"/vol/A/exec1.out.txt\", then executor 2 may read from that file.  (Essentially, this translates to a `docker run -v` flag where the container path is the same for each executor).
     * @type {Array<string>}
     * @memberof TesTask
     */
    volumes?: Array<string>;
}

/**
 * @export
 * @namespace TesTask
 */
export namespace TesTask {
    /**
     * @export
     * @enum {string}
     */
    export enum StateEnum {
        UNKNOWN = <any> 'UNKNOWN',
        QUEUED = <any> 'QUEUED',
        INITIALIZING = <any> 'INITIALIZING',
        RUNNING = <any> 'RUNNING',
        PAUSED = <any> 'PAUSED',
        COMPLETE = <any> 'COMPLETE',
        EXECUTORERROR = <any> 'EXECUTOR_ERROR',
        SYSTEMERROR = <any> 'SYSTEM_ERROR',
        CANCELED = <any> 'CANCELED'
    }
}

/**
 * TaskLog describes logging information related to a Task.
 * @export
 * @interface TesTaskLog
 */
export interface TesTaskLog {
    /**
     * When the task ended, in RFC 3339 format.
     * @type {string}
     * @memberof TesTaskLog
     */
    end_time?: string;
    /**
     * Logs for each executor
     * @type {Array<TesExecutorLog>}
     * @memberof TesTaskLog
     */
    logs?: Array<TesExecutorLog>;
    /**
     * Arbitrary logging metadata included by the implementation.
     * @type {{ [key: string]: string; }}
     * @memberof TesTaskLog
     */
    metadata?: { [key: string]: string; };
    /**
     * Information about all output files. Directory outputs are flattened into separate items.
     * @type {Array<TesOutputFileLog>}
     * @memberof TesTaskLog
     */
    outputs?: Array<TesOutputFileLog>;
    /**
     * When the task started, in RFC 3339 format.
     * @type {string}
     * @memberof TesTaskLog
     */
    start_time?: string;
    /**
     * System logs are any logs the system decides are relevant, which are not tied directly to an Executor process. Content is implementation specific: format, size, etc.  System logs may be collected here to provide convenient access.  For example, the system may include the name of the host where the task is executing, an error message that caused a SYSTEM_ERROR state (e.g. disk is full), etc.  System logs are only included in the FULL task view.
     * @type {Array<string>}
     * @memberof TesTaskLog
     */
    system_logs?: Array<string>;
}

/**
 * A tool (or described tool) describes one pairing of a tool as described in a descriptor file (which potentially describes multiple tools) and a Docker image.
 * @export
 * @interface Tool
 */
export interface Tool {
    /**
     * Contact information for the author of this tool entry in the registry. (More complex authorship information is handled by the descriptor)
     * @type {string}
     * @memberof Tool
     */
    author: string;
    /**
     * An array of IDs for the applications that are stored inside this tool (for example `https://bio.tools/tool/mytum.de/SNAP2/1`)
     * @type {Array<string>}
     * @memberof Tool
     */
    contains?: Array<string>;
    /**
     * The description of the tool.
     * @type {string}
     * @memberof Tool
     */
    description?: string;
    /**
     * A unique identifier of the tool, scoped to this registry, for example `123456` or `123456_v1`
     * @type {string}
     * @memberof Tool
     */
    id: string;
    /**
     * The version of this tool in the registry. Iterates when fields like the description, author, etc. are updated.
     * @type {string}
     * @memberof Tool
     */
    meta_version: string;
    /**
     * The organization that published the image.
     * @type {string}
     * @memberof Tool
     */
    organization: string;
    /**
     * Reports whether this tool has been signed.
     * @type {boolean}
     * @memberof Tool
     */
    signed?: boolean;
    /**
     * 
     * @type {ToolClass}
     * @memberof Tool
     */
    toolclass: ToolClass;
    /**
     * The name of the tool.
     * @type {string}
     * @memberof Tool
     */
    toolname?: string;
    /**
     * The URL for this tool in this registry, for example `http://agora.broadinstitute.org/tools/123456`
     * @type {string}
     * @memberof Tool
     */
    url: string;
    /**
     * Reports whether this tool has been verified by a specific organization or individual
     * @type {boolean}
     * @memberof Tool
     */
    verified?: boolean;
    /**
     * Source of metadata that can support a verified tool, such as an email or URL
     * @type {string}
     * @memberof Tool
     */
    verified_source?: string;
    /**
     * A list of versions for this tool
     * @type {Array<ToolVersion>}
     * @memberof Tool
     */
    versions: Array<ToolVersion>;
}

/**
 * Describes a class (type) of tool allowing us to categorize workflows, tools, and maybe even other entities (such as services) separately
 * @export
 * @interface ToolClass
 */
export interface ToolClass {
    /**
     * A longer explanation of what this class is and what it can accomplish
     * @type {string}
     * @memberof ToolClass
     */
    description?: string;
    /**
     * The unique identifier for the class
     * @type {string}
     * @memberof ToolClass
     */
    id?: string;
    /**
     * A short friendly name for the class
     * @type {string}
     * @memberof ToolClass
     */
    name?: string;
}

/**
 * A tool descriptor is a metadata document that describes one or more tools.
 * @export
 * @interface ToolDescriptor
 */
export interface ToolDescriptor {
    /**
     * The descriptor that represents this version of the tool. (CWL or WDL)
     * @type {string}
     * @memberof ToolDescriptor
     */
    descriptor: string;
    /**
     * 
     * @type {string}
     * @memberof ToolDescriptor
     */
    type: ToolDescriptor.TypeEnum;
    /**
     * Optional url to the tool descriptor used to build this image, should include version information, and can include a git hash (e.g. https://raw.githubusercontent.com/ICGC-TCGA-PanCancer/pcawg_delly_workflow/ea2a5db69bd20a42976838790bc29294df3af02b/delly_docker/Delly.cwl )
     * @type {string}
     * @memberof ToolDescriptor
     */
    url?: string;
}

/**
 * @export
 * @namespace ToolDescriptor
 */
export namespace ToolDescriptor {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        CWL = <any> 'CWL',
        WDL = <any> 'WDL',
        ISL = <any> 'ISL'
    }
}

/**
 * A tool dockerfile is a document that describes how to build a particular Docker image.
 * @export
 * @interface ToolDockerfile
 */
export interface ToolDockerfile {
    /**
     * The dockerfile content for this tool.
     * @type {string}
     * @memberof ToolDockerfile
     */
    dockerfile: string;
    /**
     * Optional url to the dockerfile used to build this image, should include version information, and can include a git hash  (e.g. https://raw.githubusercontent.com/ICGC-TCGA-PanCancer/pcawg_delly_workflow/c83478829802b4d36374870843821abe1b625a71/delly_docker/Dockerfile )
     * @type {string}
     * @memberof ToolDockerfile
     */
    url?: string;
}

/**
 * A tool document that describes how to test with one or more sample test JSON.
 * @export
 * @interface ToolTests
 */
export interface ToolTests {
    /**
     * The test JSON content for this tool.
     * @type {string}
     * @memberof ToolTests
     */
    test: string;
    /**
     * Optional url to the test JSON used to test this tool
     * @type {string}
     * @memberof ToolTests
     */
    url?: string;
}

/**
 * A tool version describes a particular iteration of a tool as described by a reference to a specific image and dockerfile.
 * @export
 * @interface ToolVersion
 */
export interface ToolVersion {
    /**
     * The type (or types) of descriptors available.
     * @type {Array<string>}
     * @memberof ToolVersion
     */
    descriptor_type?: Array<ToolVersion.DescriptorTypeEnum>;
    /**
     * Reports if this tool has a dockerfile available.
     * @type {boolean}
     * @memberof ToolVersion
     */
    dockerfile?: boolean;
    /**
     * An identifier of the version of this tool for this particular tool registry, for example `v1`
     * @type {string}
     * @memberof ToolVersion
     */
    id: string;
    /**
     * The docker path to the image (and version) for this tool. (e.g. quay.io/seqware/seqware_full/1.1)
     * @type {string}
     * @memberof ToolVersion
     */
    image?: string;
    /**
     * The version of this tool version in the registry. Iterates when fields like the description, author, etc. are updated.
     * @type {string}
     * @memberof ToolVersion
     */
    meta_version: string;
    /**
     * The name of the version.
     * @type {string}
     * @memberof ToolVersion
     */
    name?: string;
    /**
     * The URL for this tool in this registry, for example `http://agora.broadinstitute.org/tools/123456/1`
     * @type {string}
     * @memberof ToolVersion
     */
    url: string;
    /**
     * Reports whether this tool has been verified by a specific organization or individual
     * @type {boolean}
     * @memberof ToolVersion
     */
    verified?: boolean;
    /**
     * Source of metadata that can support a verified tool, such as an email or URL
     * @type {string}
     * @memberof ToolVersion
     */
    verified_source?: string;
}

/**
 * @export
 * @namespace ToolVersion
 */
export namespace ToolVersion {
    /**
     * @export
     * @enum {string}
     */
    export enum DescriptorTypeEnum {
        CWL = <any> 'CWL',
        WDL = <any> 'WDL',
        ISL = <any> 'ISL'
    }
}

/**
 * 
 * @export
 * @interface URI
 */
export interface URI {
    /**
     * 
     * @type {boolean}
     * @memberof URI
     */
    absolute?: boolean;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    authority?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    fragment?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    host?: string;
    /**
     * 
     * @type {boolean}
     * @memberof URI
     */
    opaque?: boolean;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    path?: string;
    /**
     * 
     * @type {number}
     * @memberof URI
     */
    port?: number;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    query?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    rawAuthority?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    rawFragment?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    rawPath?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    rawQuery?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    rawSchemeSpecificPart?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    rawUserInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    scheme?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    schemeSpecificPart?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    userInfo?: string;
}

/**
 * 
 * @export
 * @interface URL
 */
export interface URL {
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    authority?: string;
    /**
     * 
     * @type {any}
     * @memberof URL
     */
    content?: any;
    /**
     * 
     * @type {number}
     * @memberof URL
     */
    defaultPort?: number;
    /**
     * 
     * @type {URLStreamHandler}
     * @memberof URL
     */
    deserializedFields?: URLStreamHandler;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    file?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    host?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    path?: string;
    /**
     * 
     * @type {number}
     * @memberof URL
     */
    port?: number;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    protocol?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    query?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    ref?: string;
    /**
     * 
     * @type {number}
     * @memberof URL
     */
    serializedHashCode?: number;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    userInfo?: string;
}

/**
 * 
 * @export
 * @interface URLStreamHandler
 */
export interface URLStreamHandler {
}

/**
 * Available workflow types supported by a given instance of the service.
 * @export
 * @interface WorkflowTypeVersion
 */
export interface WorkflowTypeVersion {
    /**
     * an array of one or more acceptable types for the `workflow_type`
     * @type {Array<string>}
     * @memberof WorkflowTypeVersion
     */
    workflow_type_version?: Array<string>;
}


/**
 * DataRepositoryServiceApi - fetch parameter creator
 * @export
 */
export const DataRepositoryServiceApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a URL that can be used to fetch the object bytes.  This method only needs to be called when using an `AccessMethod` that contains an `access_id` (e.g., for servers that use signed URLs for fetching object bytes).
         * @summary Get a URL for fetching bytes.
         * @param {string} access_id An &#x60;access_id&#x60; from the &#x60;access_methods&#x60; list of a Data Object
         * @param {string} object_id An &#x60;id&#x60; of a Data Object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessURL(access_id: string, object_id: string, options: any = {}): FetchArgs {
            // verify required parameter 'access_id' is not null or undefined
            if (access_id === null || access_id === undefined) {
                throw new RequiredError('access_id','Required parameter access_id was null or undefined when calling getAccessURL.');
            }
            // verify required parameter 'object_id' is not null or undefined
            if (object_id === null || object_id === undefined) {
                throw new RequiredError('object_id','Required parameter object_id was null or undefined when calling getAccessURL.');
            }
            const localVarPath = `/api/ga4gh/v1/objects/{object_id}/access/{access_id}`
                .replace(`{${"access_id"}}`, encodeURIComponent(String(access_id)))
                .replace(`{${"object_id"}}`, encodeURIComponent(String(object_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns bundle metadata, and a list of ids that can be used to fetch bundle contents.
         * @summary Get info about a Data Bundle.
         * @param {string} bundle_id bundle_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundle(bundle_id: string, options: any = {}): FetchArgs {
            // verify required parameter 'bundle_id' is not null or undefined
            if (bundle_id === null || bundle_id === undefined) {
                throw new RequiredError('bundle_id','Required parameter bundle_id was null or undefined when calling getBundle.');
            }
            const localVarPath = `/api/ga4gh/v1/bundles/{bundle_id}`
                .replace(`{${"bundle_id"}}`, encodeURIComponent(String(bundle_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns object metadata, and a list of access methods that can be used to fetch object bytes.
         * @summary Get info about a Data Object.
         * @param {string} object_id object_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObject(object_id: string, options: any = {}): FetchArgs {
            // verify required parameter 'object_id' is not null or undefined
            if (object_id === null || object_id === undefined) {
                throw new RequiredError('object_id','Required parameter object_id was null or undefined when calling getObject.');
            }
            const localVarPath = `/api/ga4gh/v1/objects/{object_id}`
                .replace(`{${"object_id"}}`, encodeURIComponent(String(object_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataRepositoryServiceApi - functional programming interface
 * @export
 */
export const DataRepositoryServiceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns a URL that can be used to fetch the object bytes.  This method only needs to be called when using an `AccessMethod` that contains an `access_id` (e.g., for servers that use signed URLs for fetching object bytes).
         * @summary Get a URL for fetching bytes.
         * @param {string} access_id An &#x60;access_id&#x60; from the &#x60;access_methods&#x60; list of a Data Object
         * @param {string} object_id An &#x60;id&#x60; of a Data Object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessURL(access_id: string, object_id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AccessURL> {
            const localVarFetchArgs = DataRepositoryServiceApiFetchParamCreator(configuration).getAccessURL(access_id, object_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns bundle metadata, and a list of ids that can be used to fetch bundle contents.
         * @summary Get info about a Data Bundle.
         * @param {string} bundle_id bundle_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundle(bundle_id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Bundle> {
            const localVarFetchArgs = DataRepositoryServiceApiFetchParamCreator(configuration).getBundle(bundle_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns object metadata, and a list of access methods that can be used to fetch object bytes.
         * @summary Get info about a Data Object.
         * @param {string} object_id object_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObject(object_id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = DataRepositoryServiceApiFetchParamCreator(configuration).getObject(object_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DataRepositoryServiceApi - factory interface
 * @export
 */
export const DataRepositoryServiceApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Returns a URL that can be used to fetch the object bytes.  This method only needs to be called when using an `AccessMethod` that contains an `access_id` (e.g., for servers that use signed URLs for fetching object bytes).
         * @summary Get a URL for fetching bytes.
         * @param {string} access_id An &#x60;access_id&#x60; from the &#x60;access_methods&#x60; list of a Data Object
         * @param {string} object_id An &#x60;id&#x60; of a Data Object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessURL(access_id: string, object_id: string, options?: any) {
            return DataRepositoryServiceApiFp(configuration).getAccessURL(access_id, object_id, options)(fetch, basePath);
        },
        /**
         * Returns bundle metadata, and a list of ids that can be used to fetch bundle contents.
         * @summary Get info about a Data Bundle.
         * @param {string} bundle_id bundle_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundle(bundle_id: string, options?: any) {
            return DataRepositoryServiceApiFp(configuration).getBundle(bundle_id, options)(fetch, basePath);
        },
        /**
         * Returns object metadata, and a list of access methods that can be used to fetch object bytes.
         * @summary Get info about a Data Object.
         * @param {string} object_id object_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObject(object_id: string, options?: any) {
            return DataRepositoryServiceApiFp(configuration).getObject(object_id, options)(fetch, basePath);
        },
    };
};

/**
 * DataRepositoryServiceApi - object-oriented interface
 * @export
 * @class DataRepositoryServiceApi
 * @extends {BaseAPI}
 */
export class DataRepositoryServiceApi extends BaseAPI {
    /**
     * Returns a URL that can be used to fetch the object bytes.  This method only needs to be called when using an `AccessMethod` that contains an `access_id` (e.g., for servers that use signed URLs for fetching object bytes).
     * @summary Get a URL for fetching bytes.
     * @param {string} access_id An &#x60;access_id&#x60; from the &#x60;access_methods&#x60; list of a Data Object
     * @param {string} object_id An &#x60;id&#x60; of a Data Object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataRepositoryServiceApi
     */
    public getAccessURL(access_id: string, object_id: string, options?: any) {
        return DataRepositoryServiceApiFp(this.configuration).getAccessURL(access_id, object_id, options)(this.fetch, this.basePath);
    }

    /**
     * Returns bundle metadata, and a list of ids that can be used to fetch bundle contents.
     * @summary Get info about a Data Bundle.
     * @param {string} bundle_id bundle_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataRepositoryServiceApi
     */
    public getBundle(bundle_id: string, options?: any) {
        return DataRepositoryServiceApiFp(this.configuration).getBundle(bundle_id, options)(this.fetch, this.basePath);
    }

    /**
     * Returns object metadata, and a list of access methods that can be used to fetch object bytes.
     * @summary Get info about a Data Object.
     * @param {string} object_id object_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataRepositoryServiceApi
     */
    public getObject(object_id: string, options?: any) {
        return DataRepositoryServiceApiFp(this.configuration).getObject(object_id, options)(this.fetch, this.basePath);
    }

}

/**
 * TaskServiceApi - fetch parameter creator
 * @export
 */
export const TaskServiceApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel a task.
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTask(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling cancelTask.');
            }
            const localVarPath = `/api/ga4gh/v1/tasks/{id}:cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new task.
         * @param {TesTask} body body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask(body: TesTask, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createTask.');
            }
            const localVarPath = `/api/ga4gh/v1/tasks`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TesTask" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetServiceInfo provides information about the service, such as storage details, resource availability, and  other documentation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceInfo1(options: any = {}): FetchArgs {
            const localVarPath = `/api/ga4gh/v1/tasks/service-info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a task. TaskView is requested as such: \"v1/tasks/{id}?view=FULL\"
         * @param {string} id id
         * @param {'MINIMAL' | 'BASIC' | 'FULL'} [view] OPTIONAL. Affects the fields included in the returned Task messages. See TaskView below.   - MINIMAL: Task message will include ONLY the fields:   Task.Id   Task.State  - BASIC: Task message will include all fields EXCEPT:   Task.ExecutorLog.stdout   Task.ExecutorLog.stderr   Input.content   TaskLog.system_logs  - FULL: Task message includes all fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask(id: string, view?: 'MINIMAL' | 'BASIC' | 'FULL', options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getTask.');
            }
            const localVarPath = `/api/ga4gh/v1/tasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (view !== undefined) {
                localVarQueryParameter['view'] = view;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List tasks. TaskView is requested as such: \"v1/tasks?view=BASIC\"
         * @param {string} [name_prefix] OPTIONAL. Filter the list to include tasks where the name matches this prefix. If unspecified, no task name filtering is done.
         * @param {number} [page_size] OPTIONAL. Number of tasks to return in one page. Must be less than 2048. Defaults to 256.
         * @param {string} [page_token] OPTIONAL. Page token is used to retrieve the next page of results. If unspecified, returns the first page of results. See ListTasksResponse.next_page_token
         * @param {'MINIMAL' | 'BASIC' | 'FULL'} [view] OPTIONAL. Affects the fields included in the returned Task messages. See TaskView below.   - MINIMAL: Task message will include ONLY the fields:   Task.Id   Task.State  - BASIC: Task message will include all fields EXCEPT:   Task.ExecutorLog.stdout   Task.ExecutorLog.stderr   Input.content   TaskLog.system_logs  - FULL: Task message includes all fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTasks(name_prefix?: string, page_size?: number, page_token?: string, view?: 'MINIMAL' | 'BASIC' | 'FULL', options: any = {}): FetchArgs {
            const localVarPath = `/api/ga4gh/v1/tasks`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (name_prefix !== undefined) {
                localVarQueryParameter['name_prefix'] = name_prefix;
            }

            if (page_size !== undefined) {
                localVarQueryParameter['page_size'] = page_size;
            }

            if (page_token !== undefined) {
                localVarQueryParameter['page_token'] = page_token;
            }

            if (view !== undefined) {
                localVarQueryParameter['view'] = view;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskServiceApi - functional programming interface
 * @export
 */
export const TaskServiceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel a task.
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTask(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TesCancelTaskResponse> {
            const localVarFetchArgs = TaskServiceApiFetchParamCreator(configuration).cancelTask(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create a new task.
         * @param {TesTask} body body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask(body: TesTask, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TesCreateTaskResponse> {
            const localVarFetchArgs = TaskServiceApiFetchParamCreator(configuration).createTask(body, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary GetServiceInfo provides information about the service, such as storage details, resource availability, and  other documentation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceInfo1(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TesServiceInfo> {
            const localVarFetchArgs = TaskServiceApiFetchParamCreator(configuration).getServiceInfo1(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a task. TaskView is requested as such: \"v1/tasks/{id}?view=FULL\"
         * @param {string} id id
         * @param {'MINIMAL' | 'BASIC' | 'FULL'} [view] OPTIONAL. Affects the fields included in the returned Task messages. See TaskView below.   - MINIMAL: Task message will include ONLY the fields:   Task.Id   Task.State  - BASIC: Task message will include all fields EXCEPT:   Task.ExecutorLog.stdout   Task.ExecutorLog.stderr   Input.content   TaskLog.system_logs  - FULL: Task message includes all fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask(id: string, view?: 'MINIMAL' | 'BASIC' | 'FULL', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TesTask> {
            const localVarFetchArgs = TaskServiceApiFetchParamCreator(configuration).getTask(id, view, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary List tasks. TaskView is requested as such: \"v1/tasks?view=BASIC\"
         * @param {string} [name_prefix] OPTIONAL. Filter the list to include tasks where the name matches this prefix. If unspecified, no task name filtering is done.
         * @param {number} [page_size] OPTIONAL. Number of tasks to return in one page. Must be less than 2048. Defaults to 256.
         * @param {string} [page_token] OPTIONAL. Page token is used to retrieve the next page of results. If unspecified, returns the first page of results. See ListTasksResponse.next_page_token
         * @param {'MINIMAL' | 'BASIC' | 'FULL'} [view] OPTIONAL. Affects the fields included in the returned Task messages. See TaskView below.   - MINIMAL: Task message will include ONLY the fields:   Task.Id   Task.State  - BASIC: Task message will include all fields EXCEPT:   Task.ExecutorLog.stdout   Task.ExecutorLog.stderr   Input.content   TaskLog.system_logs  - FULL: Task message includes all fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTasks(name_prefix?: string, page_size?: number, page_token?: string, view?: 'MINIMAL' | 'BASIC' | 'FULL', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TesListTasksResponse> {
            const localVarFetchArgs = TaskServiceApiFetchParamCreator(configuration).listTasks(name_prefix, page_size, page_token, view, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TaskServiceApi - factory interface
 * @export
 */
export const TaskServiceApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Cancel a task.
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTask(id: string, options?: any) {
            return TaskServiceApiFp(configuration).cancelTask(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create a new task.
         * @param {TesTask} body body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask(body: TesTask, options?: any) {
            return TaskServiceApiFp(configuration).createTask(body, options)(fetch, basePath);
        },
        /**
         * 
         * @summary GetServiceInfo provides information about the service, such as storage details, resource availability, and  other documentation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceInfo1(options?: any) {
            return TaskServiceApiFp(configuration).getServiceInfo1(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a task. TaskView is requested as such: \"v1/tasks/{id}?view=FULL\"
         * @param {string} id id
         * @param {'MINIMAL' | 'BASIC' | 'FULL'} [view] OPTIONAL. Affects the fields included in the returned Task messages. See TaskView below.   - MINIMAL: Task message will include ONLY the fields:   Task.Id   Task.State  - BASIC: Task message will include all fields EXCEPT:   Task.ExecutorLog.stdout   Task.ExecutorLog.stderr   Input.content   TaskLog.system_logs  - FULL: Task message includes all fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask(id: string, view?: 'MINIMAL' | 'BASIC' | 'FULL', options?: any) {
            return TaskServiceApiFp(configuration).getTask(id, view, options)(fetch, basePath);
        },
        /**
         * 
         * @summary List tasks. TaskView is requested as such: \"v1/tasks?view=BASIC\"
         * @param {string} [name_prefix] OPTIONAL. Filter the list to include tasks where the name matches this prefix. If unspecified, no task name filtering is done.
         * @param {number} [page_size] OPTIONAL. Number of tasks to return in one page. Must be less than 2048. Defaults to 256.
         * @param {string} [page_token] OPTIONAL. Page token is used to retrieve the next page of results. If unspecified, returns the first page of results. See ListTasksResponse.next_page_token
         * @param {'MINIMAL' | 'BASIC' | 'FULL'} [view] OPTIONAL. Affects the fields included in the returned Task messages. See TaskView below.   - MINIMAL: Task message will include ONLY the fields:   Task.Id   Task.State  - BASIC: Task message will include all fields EXCEPT:   Task.ExecutorLog.stdout   Task.ExecutorLog.stderr   Input.content   TaskLog.system_logs  - FULL: Task message includes all fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTasks(name_prefix?: string, page_size?: number, page_token?: string, view?: 'MINIMAL' | 'BASIC' | 'FULL', options?: any) {
            return TaskServiceApiFp(configuration).listTasks(name_prefix, page_size, page_token, view, options)(fetch, basePath);
        },
    };
};

/**
 * TaskServiceApi - object-oriented interface
 * @export
 * @class TaskServiceApi
 * @extends {BaseAPI}
 */
export class TaskServiceApi extends BaseAPI {
    /**
     * 
     * @summary Cancel a task.
     * @param {string} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskServiceApi
     */
    public cancelTask(id: string, options?: any) {
        return TaskServiceApiFp(this.configuration).cancelTask(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create a new task.
     * @param {TesTask} body body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskServiceApi
     */
    public createTask(body: TesTask, options?: any) {
        return TaskServiceApiFp(this.configuration).createTask(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary GetServiceInfo provides information about the service, such as storage details, resource availability, and  other documentation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskServiceApi
     */
    public getServiceInfo1(options?: any) {
        return TaskServiceApiFp(this.configuration).getServiceInfo1(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a task. TaskView is requested as such: \"v1/tasks/{id}?view=FULL\"
     * @param {string} id id
     * @param {'MINIMAL' | 'BASIC' | 'FULL'} [view] OPTIONAL. Affects the fields included in the returned Task messages. See TaskView below.   - MINIMAL: Task message will include ONLY the fields:   Task.Id   Task.State  - BASIC: Task message will include all fields EXCEPT:   Task.ExecutorLog.stdout   Task.ExecutorLog.stderr   Input.content   TaskLog.system_logs  - FULL: Task message includes all fields.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskServiceApi
     */
    public getTask(id: string, view?: 'MINIMAL' | 'BASIC' | 'FULL', options?: any) {
        return TaskServiceApiFp(this.configuration).getTask(id, view, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary List tasks. TaskView is requested as such: \"v1/tasks?view=BASIC\"
     * @param {string} [name_prefix] OPTIONAL. Filter the list to include tasks where the name matches this prefix. If unspecified, no task name filtering is done.
     * @param {number} [page_size] OPTIONAL. Number of tasks to return in one page. Must be less than 2048. Defaults to 256.
     * @param {string} [page_token] OPTIONAL. Page token is used to retrieve the next page of results. If unspecified, returns the first page of results. See ListTasksResponse.next_page_token
     * @param {'MINIMAL' | 'BASIC' | 'FULL'} [view] OPTIONAL. Affects the fields included in the returned Task messages. See TaskView below.   - MINIMAL: Task message will include ONLY the fields:   Task.Id   Task.State  - BASIC: Task message will include all fields EXCEPT:   Task.ExecutorLog.stdout   Task.ExecutorLog.stderr   Input.content   TaskLog.system_logs  - FULL: Task message includes all fields.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskServiceApi
     */
    public listTasks(name_prefix?: string, page_size?: number, page_token?: string, view?: 'MINIMAL' | 'BASIC' | 'FULL', options?: any) {
        return TaskServiceApiFp(this.configuration).listTasks(name_prefix, page_size, page_token, view, options)(this.fetch, this.basePath);
    }

}

/**
 * ToolsRegistryServiceApi - fetch parameter creator
 * @export
 */
export const ToolsRegistryServiceApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return some metadata that is useful for describing this registry
         * @summary Return some metadata that is useful for describing this registry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataGet(options: any = {}): FetchArgs {
            const localVarPath = `/api/ga4gh/v1/metadata`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns all tool-classes available 
         * @summary List all tool types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolClassesGet(options: any = {}): FetchArgs {
            const localVarPath = `/api/ga4gh/v1/tool-classes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns all tools available or a filtered subset using metadata query parameters. 
         * @summary List all tools
         * @param {string} [author] The author of the tool (TODO a thought occurs, are we assuming that the author of the CWL and the image are the same?).
         * @param {string} [description] The description of the tool.
         * @param {string} [id] A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {number} [limit] Amount of records to return in a given page.  By default it is 1000.
         * @param {string} [name] The name of the image.
         * @param {string} [offset] Start index of paging. Pagination results can be based on numbers or other values chosen by the registry implementor (for example, SHA values). If this exceeds the current result set return an empty set.  If not specified in the request this will start at the beginning of the results.
         * @param {string} [organization] The organization in the registry that published the image.
         * @param {string} [registry] The image registry that contains the image.
         * @param {string} [toolname] The name of the tool.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsGet(author?: string, description?: string, id?: string, limit?: number, name?: string, offset?: string, organization?: string, registry?: string, toolname?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/ga4gh/v1/tools`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (organization !== undefined) {
                localVarQueryParameter['organization'] = organization;
            }

            if (registry !== undefined) {
                localVarQueryParameter['registry'] = registry;
            }

            if (toolname !== undefined) {
                localVarQueryParameter['toolname'] = toolname;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns one specific tool (which has ToolVersions nested inside it)
         * @summary List one specific tool, acts as an anchor for self references
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdGet(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling toolsIdGet.');
            }
            const localVarPath = `/api/ga4gh/v1/tools/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all versions of the specified tool
         * @summary List versions of a tool
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsGet(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling toolsIdVersionsGet.');
            }
            const localVarPath = `/api/ga4gh/v1/tools/{id}/versions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the dockerfile for the specified image.
         * @summary Get the dockerfile for the specified image.
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdDockerfileGet(id: string, version_id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling toolsIdVersionsVersionIdDockerfileGet.');
            }
            // verify required parameter 'version_id' is not null or undefined
            if (version_id === null || version_id === undefined) {
                throw new RequiredError('version_id','Required parameter version_id was null or undefined when calling toolsIdVersionsVersionIdDockerfileGet.');
            }
            const localVarPath = `/api/ga4gh/v1/tools/{id}/versions/{version-id}/dockerfile`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version-id"}}`, encodeURIComponent(String(version_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint returns one specific tool version
         * @summary List one specific tool version, acts as an anchor for self references
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {string} version_id An identifier of the tool version, scoped to this registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdGet(id: string, version_id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling toolsIdVersionsVersionIdGet.');
            }
            // verify required parameter 'version_id' is not null or undefined
            if (version_id === null || version_id === undefined) {
                throw new RequiredError('version_id','Required parameter version_id was null or undefined when calling toolsIdVersionsVersionIdGet.');
            }
            const localVarPath = `/api/ga4gh/v1/tools/{id}/versions/{version-id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version-id"}}`, encodeURIComponent(String(version_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the CWL or WDL descriptor for the specified tool.
         * @summary Get the tool descriptor (CWL/WDL) for the specified tool.
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {'\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"'} type The output type of the descriptor. If not specified it is up to the underlying implementation to determine which output type to return. Plain types return the bare descriptor while the \&quot;non-plain\&quot; types return a descriptor wrapped with metadata
         * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdTypeDescriptorGet(id: string, type: '\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"', version_id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling toolsIdVersionsVersionIdTypeDescriptorGet.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling toolsIdVersionsVersionIdTypeDescriptorGet.');
            }
            // verify required parameter 'version_id' is not null or undefined
            if (version_id === null || version_id === undefined) {
                throw new RequiredError('version_id','Required parameter version_id was null or undefined when calling toolsIdVersionsVersionIdTypeDescriptorGet.');
            }
            const localVarPath = `/api/ga4gh/v1/tools/{id}/versions/{version-id}/{type}/descriptor`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"version-id"}}`, encodeURIComponent(String(version_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns additional CWL or WDL descriptors for the specified tool in the same or subdirectories
         * @summary Get additional tool descriptor files (CWL/WDL) relative to the main file
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {string} relative_path A relative path to the additional file (same directory or subdirectories), for example &#39;foo.cwl&#39; would return a &#39;foo.cwl&#39; from the same directory as the main descriptor
         * @param {'\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"'} type The output type of the descriptor. If not specified it is up to the underlying implementation to determine which output type to return.  Plain types return the bare descriptor while the \&quot;non-plain\&quot; types return a descriptor wrapped with metadata
         * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdTypeDescriptorRelativePathGet(id: string, relative_path: string, type: '\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"', version_id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling toolsIdVersionsVersionIdTypeDescriptorRelativePathGet.');
            }
            // verify required parameter 'relative_path' is not null or undefined
            if (relative_path === null || relative_path === undefined) {
                throw new RequiredError('relative_path','Required parameter relative_path was null or undefined when calling toolsIdVersionsVersionIdTypeDescriptorRelativePathGet.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling toolsIdVersionsVersionIdTypeDescriptorRelativePathGet.');
            }
            // verify required parameter 'version_id' is not null or undefined
            if (version_id === null || version_id === undefined) {
                throw new RequiredError('version_id','Required parameter version_id was null or undefined when calling toolsIdVersionsVersionIdTypeDescriptorRelativePathGet.');
            }
            const localVarPath = `/api/ga4gh/v1/tools/{id}/versions/{version-id}/{type}/descriptor/{relative-path}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"relative-path"}}`, encodeURIComponent(String(relative_path)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"version-id"}}`, encodeURIComponent(String(version_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an array of test JSONs suitable for use with this descriptor type.
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {'\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"'} type The output type of the descriptor. If not specified it is up to the underlying implementation to determine which output type to return. Plain types return the bare descriptor while the \&quot;non-plain\&quot; types return a descriptor wrapped with metadata
         * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdTypeTestsGet(id: string, type: '\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"', version_id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling toolsIdVersionsVersionIdTypeTestsGet.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling toolsIdVersionsVersionIdTypeTestsGet.');
            }
            // verify required parameter 'version_id' is not null or undefined
            if (version_id === null || version_id === undefined) {
                throw new RequiredError('version_id','Required parameter version_id was null or undefined when calling toolsIdVersionsVersionIdTypeTestsGet.');
            }
            const localVarPath = `/api/ga4gh/v1/tools/{id}/versions/{version-id}/{type}/tests`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"version-id"}}`, encodeURIComponent(String(version_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ToolsRegistryServiceApi - functional programming interface
 * @export
 */
export const ToolsRegistryServiceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Return some metadata that is useful for describing this registry
         * @summary Return some metadata that is useful for describing this registry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Metadata> {
            const localVarFetchArgs = ToolsRegistryServiceApiFetchParamCreator(configuration).metadataGet(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns all tool-classes available 
         * @summary List all tool types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolClassesGet(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ToolClass>> {
            const localVarFetchArgs = ToolsRegistryServiceApiFetchParamCreator(configuration).toolClassesGet(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns all tools available or a filtered subset using metadata query parameters. 
         * @summary List all tools
         * @param {string} [author] The author of the tool (TODO a thought occurs, are we assuming that the author of the CWL and the image are the same?).
         * @param {string} [description] The description of the tool.
         * @param {string} [id] A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {number} [limit] Amount of records to return in a given page.  By default it is 1000.
         * @param {string} [name] The name of the image.
         * @param {string} [offset] Start index of paging. Pagination results can be based on numbers or other values chosen by the registry implementor (for example, SHA values). If this exceeds the current result set return an empty set.  If not specified in the request this will start at the beginning of the results.
         * @param {string} [organization] The organization in the registry that published the image.
         * @param {string} [registry] The image registry that contains the image.
         * @param {string} [toolname] The name of the tool.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsGet(author?: string, description?: string, id?: string, limit?: number, name?: string, offset?: string, organization?: string, registry?: string, toolname?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Tool>> {
            const localVarFetchArgs = ToolsRegistryServiceApiFetchParamCreator(configuration).toolsGet(author, description, id, limit, name, offset, organization, registry, toolname, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns one specific tool (which has ToolVersions nested inside it)
         * @summary List one specific tool, acts as an anchor for self references
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdGet(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Tool> {
            const localVarFetchArgs = ToolsRegistryServiceApiFetchParamCreator(configuration).toolsIdGet(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns all versions of the specified tool
         * @summary List versions of a tool
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsGet(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ToolVersion>> {
            const localVarFetchArgs = ToolsRegistryServiceApiFetchParamCreator(configuration).toolsIdVersionsGet(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the dockerfile for the specified image.
         * @summary Get the dockerfile for the specified image.
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdDockerfileGet(id: string, version_id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ToolDockerfile> {
            const localVarFetchArgs = ToolsRegistryServiceApiFetchParamCreator(configuration).toolsIdVersionsVersionIdDockerfileGet(id, version_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint returns one specific tool version
         * @summary List one specific tool version, acts as an anchor for self references
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {string} version_id An identifier of the tool version, scoped to this registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdGet(id: string, version_id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ToolVersion> {
            const localVarFetchArgs = ToolsRegistryServiceApiFetchParamCreator(configuration).toolsIdVersionsVersionIdGet(id, version_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns the CWL or WDL descriptor for the specified tool.
         * @summary Get the tool descriptor (CWL/WDL) for the specified tool.
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {'\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"'} type The output type of the descriptor. If not specified it is up to the underlying implementation to determine which output type to return. Plain types return the bare descriptor while the \&quot;non-plain\&quot; types return a descriptor wrapped with metadata
         * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdTypeDescriptorGet(id: string, type: '\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"', version_id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ToolDescriptor> {
            const localVarFetchArgs = ToolsRegistryServiceApiFetchParamCreator(configuration).toolsIdVersionsVersionIdTypeDescriptorGet(id, type, version_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns additional CWL or WDL descriptors for the specified tool in the same or subdirectories
         * @summary Get additional tool descriptor files (CWL/WDL) relative to the main file
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {string} relative_path A relative path to the additional file (same directory or subdirectories), for example &#39;foo.cwl&#39; would return a &#39;foo.cwl&#39; from the same directory as the main descriptor
         * @param {'\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"'} type The output type of the descriptor. If not specified it is up to the underlying implementation to determine which output type to return.  Plain types return the bare descriptor while the \&quot;non-plain\&quot; types return a descriptor wrapped with metadata
         * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdTypeDescriptorRelativePathGet(id: string, relative_path: string, type: '\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"', version_id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ToolDescriptor> {
            const localVarFetchArgs = ToolsRegistryServiceApiFetchParamCreator(configuration).toolsIdVersionsVersionIdTypeDescriptorRelativePathGet(id, relative_path, type, version_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get an array of test JSONs suitable for use with this descriptor type.
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {'\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"'} type The output type of the descriptor. If not specified it is up to the underlying implementation to determine which output type to return. Plain types return the bare descriptor while the \&quot;non-plain\&quot; types return a descriptor wrapped with metadata
         * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdTypeTestsGet(id: string, type: '\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"', version_id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ToolTests>> {
            const localVarFetchArgs = ToolsRegistryServiceApiFetchParamCreator(configuration).toolsIdVersionsVersionIdTypeTestsGet(id, type, version_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ToolsRegistryServiceApi - factory interface
 * @export
 */
export const ToolsRegistryServiceApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Return some metadata that is useful for describing this registry
         * @summary Return some metadata that is useful for describing this registry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataGet(options?: any) {
            return ToolsRegistryServiceApiFp(configuration).metadataGet(options)(fetch, basePath);
        },
        /**
         * This endpoint returns all tool-classes available 
         * @summary List all tool types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolClassesGet(options?: any) {
            return ToolsRegistryServiceApiFp(configuration).toolClassesGet(options)(fetch, basePath);
        },
        /**
         * This endpoint returns all tools available or a filtered subset using metadata query parameters. 
         * @summary List all tools
         * @param {string} [author] The author of the tool (TODO a thought occurs, are we assuming that the author of the CWL and the image are the same?).
         * @param {string} [description] The description of the tool.
         * @param {string} [id] A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {number} [limit] Amount of records to return in a given page.  By default it is 1000.
         * @param {string} [name] The name of the image.
         * @param {string} [offset] Start index of paging. Pagination results can be based on numbers or other values chosen by the registry implementor (for example, SHA values). If this exceeds the current result set return an empty set.  If not specified in the request this will start at the beginning of the results.
         * @param {string} [organization] The organization in the registry that published the image.
         * @param {string} [registry] The image registry that contains the image.
         * @param {string} [toolname] The name of the tool.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsGet(author?: string, description?: string, id?: string, limit?: number, name?: string, offset?: string, organization?: string, registry?: string, toolname?: string, options?: any) {
            return ToolsRegistryServiceApiFp(configuration).toolsGet(author, description, id, limit, name, offset, organization, registry, toolname, options)(fetch, basePath);
        },
        /**
         * This endpoint returns one specific tool (which has ToolVersions nested inside it)
         * @summary List one specific tool, acts as an anchor for self references
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdGet(id: string, options?: any) {
            return ToolsRegistryServiceApiFp(configuration).toolsIdGet(id, options)(fetch, basePath);
        },
        /**
         * Returns all versions of the specified tool
         * @summary List versions of a tool
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsGet(id: string, options?: any) {
            return ToolsRegistryServiceApiFp(configuration).toolsIdVersionsGet(id, options)(fetch, basePath);
        },
        /**
         * Returns the dockerfile for the specified image.
         * @summary Get the dockerfile for the specified image.
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdDockerfileGet(id: string, version_id: string, options?: any) {
            return ToolsRegistryServiceApiFp(configuration).toolsIdVersionsVersionIdDockerfileGet(id, version_id, options)(fetch, basePath);
        },
        /**
         * This endpoint returns one specific tool version
         * @summary List one specific tool version, acts as an anchor for self references
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {string} version_id An identifier of the tool version, scoped to this registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdGet(id: string, version_id: string, options?: any) {
            return ToolsRegistryServiceApiFp(configuration).toolsIdVersionsVersionIdGet(id, version_id, options)(fetch, basePath);
        },
        /**
         * Returns the CWL or WDL descriptor for the specified tool.
         * @summary Get the tool descriptor (CWL/WDL) for the specified tool.
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {'\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"'} type The output type of the descriptor. If not specified it is up to the underlying implementation to determine which output type to return. Plain types return the bare descriptor while the \&quot;non-plain\&quot; types return a descriptor wrapped with metadata
         * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdTypeDescriptorGet(id: string, type: '\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"', version_id: string, options?: any) {
            return ToolsRegistryServiceApiFp(configuration).toolsIdVersionsVersionIdTypeDescriptorGet(id, type, version_id, options)(fetch, basePath);
        },
        /**
         * Returns additional CWL or WDL descriptors for the specified tool in the same or subdirectories
         * @summary Get additional tool descriptor files (CWL/WDL) relative to the main file
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {string} relative_path A relative path to the additional file (same directory or subdirectories), for example &#39;foo.cwl&#39; would return a &#39;foo.cwl&#39; from the same directory as the main descriptor
         * @param {'\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"'} type The output type of the descriptor. If not specified it is up to the underlying implementation to determine which output type to return.  Plain types return the bare descriptor while the \&quot;non-plain\&quot; types return a descriptor wrapped with metadata
         * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdTypeDescriptorRelativePathGet(id: string, relative_path: string, type: '\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"', version_id: string, options?: any) {
            return ToolsRegistryServiceApiFp(configuration).toolsIdVersionsVersionIdTypeDescriptorRelativePathGet(id, relative_path, type, version_id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get an array of test JSONs suitable for use with this descriptor type.
         * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
         * @param {'\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"'} type The output type of the descriptor. If not specified it is up to the underlying implementation to determine which output type to return. Plain types return the bare descriptor while the \&quot;non-plain\&quot; types return a descriptor wrapped with metadata
         * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toolsIdVersionsVersionIdTypeTestsGet(id: string, type: '\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"', version_id: string, options?: any) {
            return ToolsRegistryServiceApiFp(configuration).toolsIdVersionsVersionIdTypeTestsGet(id, type, version_id, options)(fetch, basePath);
        },
    };
};

/**
 * ToolsRegistryServiceApi - object-oriented interface
 * @export
 * @class ToolsRegistryServiceApi
 * @extends {BaseAPI}
 */
export class ToolsRegistryServiceApi extends BaseAPI {
    /**
     * Return some metadata that is useful for describing this registry
     * @summary Return some metadata that is useful for describing this registry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsRegistryServiceApi
     */
    public metadataGet(options?: any) {
        return ToolsRegistryServiceApiFp(this.configuration).metadataGet(options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns all tool-classes available 
     * @summary List all tool types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsRegistryServiceApi
     */
    public toolClassesGet(options?: any) {
        return ToolsRegistryServiceApiFp(this.configuration).toolClassesGet(options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns all tools available or a filtered subset using metadata query parameters. 
     * @summary List all tools
     * @param {string} [author] The author of the tool (TODO a thought occurs, are we assuming that the author of the CWL and the image are the same?).
     * @param {string} [description] The description of the tool.
     * @param {string} [id] A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
     * @param {number} [limit] Amount of records to return in a given page.  By default it is 1000.
     * @param {string} [name] The name of the image.
     * @param {string} [offset] Start index of paging. Pagination results can be based on numbers or other values chosen by the registry implementor (for example, SHA values). If this exceeds the current result set return an empty set.  If not specified in the request this will start at the beginning of the results.
     * @param {string} [organization] The organization in the registry that published the image.
     * @param {string} [registry] The image registry that contains the image.
     * @param {string} [toolname] The name of the tool.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsRegistryServiceApi
     */
    public toolsGet(author?: string, description?: string, id?: string, limit?: number, name?: string, offset?: string, organization?: string, registry?: string, toolname?: string, options?: any) {
        return ToolsRegistryServiceApiFp(this.configuration).toolsGet(author, description, id, limit, name, offset, organization, registry, toolname, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns one specific tool (which has ToolVersions nested inside it)
     * @summary List one specific tool, acts as an anchor for self references
     * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsRegistryServiceApi
     */
    public toolsIdGet(id: string, options?: any) {
        return ToolsRegistryServiceApiFp(this.configuration).toolsIdGet(id, options)(this.fetch, this.basePath);
    }

    /**
     * Returns all versions of the specified tool
     * @summary List versions of a tool
     * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsRegistryServiceApi
     */
    public toolsIdVersionsGet(id: string, options?: any) {
        return ToolsRegistryServiceApiFp(this.configuration).toolsIdVersionsGet(id, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the dockerfile for the specified image.
     * @summary Get the dockerfile for the specified image.
     * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
     * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsRegistryServiceApi
     */
    public toolsIdVersionsVersionIdDockerfileGet(id: string, version_id: string, options?: any) {
        return ToolsRegistryServiceApiFp(this.configuration).toolsIdVersionsVersionIdDockerfileGet(id, version_id, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint returns one specific tool version
     * @summary List one specific tool version, acts as an anchor for self references
     * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
     * @param {string} version_id An identifier of the tool version, scoped to this registry, for example &#x60;v1&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsRegistryServiceApi
     */
    public toolsIdVersionsVersionIdGet(id: string, version_id: string, options?: any) {
        return ToolsRegistryServiceApiFp(this.configuration).toolsIdVersionsVersionIdGet(id, version_id, options)(this.fetch, this.basePath);
    }

    /**
     * Returns the CWL or WDL descriptor for the specified tool.
     * @summary Get the tool descriptor (CWL/WDL) for the specified tool.
     * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
     * @param {'\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"'} type The output type of the descriptor. If not specified it is up to the underlying implementation to determine which output type to return. Plain types return the bare descriptor while the \&quot;non-plain\&quot; types return a descriptor wrapped with metadata
     * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsRegistryServiceApi
     */
    public toolsIdVersionsVersionIdTypeDescriptorGet(id: string, type: '\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"', version_id: string, options?: any) {
        return ToolsRegistryServiceApiFp(this.configuration).toolsIdVersionsVersionIdTypeDescriptorGet(id, type, version_id, options)(this.fetch, this.basePath);
    }

    /**
     * Returns additional CWL or WDL descriptors for the specified tool in the same or subdirectories
     * @summary Get additional tool descriptor files (CWL/WDL) relative to the main file
     * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
     * @param {string} relative_path A relative path to the additional file (same directory or subdirectories), for example &#39;foo.cwl&#39; would return a &#39;foo.cwl&#39; from the same directory as the main descriptor
     * @param {'\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"'} type The output type of the descriptor. If not specified it is up to the underlying implementation to determine which output type to return.  Plain types return the bare descriptor while the \&quot;non-plain\&quot; types return a descriptor wrapped with metadata
     * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsRegistryServiceApi
     */
    public toolsIdVersionsVersionIdTypeDescriptorRelativePathGet(id: string, relative_path: string, type: '\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"', version_id: string, options?: any) {
        return ToolsRegistryServiceApiFp(this.configuration).toolsIdVersionsVersionIdTypeDescriptorRelativePathGet(id, relative_path, type, version_id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get an array of test JSONs suitable for use with this descriptor type.
     * @param {string} id A unique identifier of the tool, scoped to this registry, for example &#x60;123456&#x60;
     * @param {'\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"'} type The output type of the descriptor. If not specified it is up to the underlying implementation to determine which output type to return. Plain types return the bare descriptor while the \&quot;non-plain\&quot; types return a descriptor wrapped with metadata
     * @param {string} version_id An identifier of the tool version for this particular tool registry, for example &#x60;v1&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsRegistryServiceApi
     */
    public toolsIdVersionsVersionIdTypeTestsGet(id: string, type: '\"CWL\"' | '\"WDL\"' | '\"plain-CWL\"' | '\"plain-WDL\"', version_id: string, options?: any) {
        return ToolsRegistryServiceApiFp(this.configuration).toolsIdVersionsVersionIdTypeTestsGet(id, type, version_id, options)(this.fetch, this.basePath);
    }

}

/**
 * WorkflowExecutionServiceApi - fetch parameter creator
 * @export
 */
export const WorkflowExecutionServiceApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel a running workflow.
         * @param {string} run_id run_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRun(run_id: string, options: any = {}): FetchArgs {
            // verify required parameter 'run_id' is not null or undefined
            if (run_id === null || run_id === undefined) {
                throw new RequiredError('run_id','Required parameter run_id was null or undefined when calling cancelRun.');
            }
            const localVarPath = `/api/ga4gh/v1/runs/{run_id}/cancel`
                .replace(`{${"run_id"}}`, encodeURIComponent(String(run_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint provides detailed information about a given workflow run. The returned result has information about the outputs produced by this workflow (if available), a log object which allows the stderr and stdout to be retrieved, a log array so stderr/stdout for individual tasks can be retrieved, and the overall state of the workflow run (e.g. RUNNING, see the State section).
         * @summary Get detailed info about a workflow run.
         * @param {string} run_id run_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunLog(run_id: string, options: any = {}): FetchArgs {
            // verify required parameter 'run_id' is not null or undefined
            if (run_id === null || run_id === undefined) {
                throw new RequiredError('run_id','Required parameter run_id was null or undefined when calling getRunLog.');
            }
            const localVarPath = `/api/ga4gh/v1/runs/{run_id}`
                .replace(`{${"run_id"}}`, encodeURIComponent(String(run_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This provides an abbreviated (and likely fast depending on implementation) status of the running workflow, returning a simple result with the overall state of the workflow run (e.g. RUNNING, see the State section).
         * @summary Get quick status info about a workflow run.
         * @param {string} run_id run_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunStatus(run_id: string, options: any = {}): FetchArgs {
            // verify required parameter 'run_id' is not null or undefined
            if (run_id === null || run_id === undefined) {
                throw new RequiredError('run_id','Required parameter run_id was null or undefined when calling getRunStatus.');
            }
            const localVarPath = `/api/ga4gh/v1/runs/{run_id}/status`
                .replace(`{${"run_id"}}`, encodeURIComponent(String(run_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * May include information related (but not limited to) the workflow descriptor formats, versions supported, the WES API versions supported, and information about general service availability.
         * @summary Get information about Workflow Execution Service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceInfo(options: any = {}): FetchArgs {
            const localVarPath = `/api/ga4gh/v1/service-info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This list should be provided in a stable ordering. (The actual ordering is implementation dependent.) When paging through the list, the client should not make assumptions about live updates, but should assume the contents of the list reflect the workflow list at the moment that the first page is requested.  To monitor a specific workflow run, use GetRunStatus or GetRunLog.
         * @summary List the workflow runs.
         * @param {number} [page_size] OPTIONAL The preferred number of workflow runs to return in a page. If not provided, the implementation should use a default page size. The implementation must not return more items than &#x60;page_size&#x60;, but it may return fewer.  Clients should not assume that if fewer than &#x60;page_size&#x60; items are returned that all items have been returned.  The availability of additional pages is indicated by the value of &#x60;next_page_token&#x60; in the response.
         * @param {string} [page_token] OPTIONAL Token to use to indicate where to start getting results. If unspecified, return the first page of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRuns(page_size?: number, page_token?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/ga4gh/v1/runs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page_size !== undefined) {
                localVarQueryParameter['page_size'] = page_size;
            }

            if (page_token !== undefined) {
                localVarQueryParameter['page_token'] = page_token;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint creates a new workflow run and returns a `RunId` to monitor its progress.  The `workflow_attachment` array may be used to upload files that are required to execute the workflow, including the primary workflow, tools imported by the workflow, other files referenced by the workflow, or files which are part of the input.  The implementation should stage these files to a temporary directory and execute the workflow from there. These parts must have a Content-Disposition header with a \"filename\" provided for each part.  Filenames may include subdirectories, but must not include references to parent directories with '..' -- implementations should guard against maliciously constructed filenames.  The `workflow_url` is either an absolute URL to a workflow file that is accessible by the WES endpoint, or a relative URL corresponding to one of the files attached using `workflow_attachment`.  The `workflow_params` JSON object specifies input parameters, such as input files.  The exact format of the JSON object depends on the conventions of the workflow language being used.  Input files should either be absolute URLs, or relative URLs corresponding to files uploaded using `workflow_attachment`.  The WES endpoint must understand and be able to access URLs supplied in the input.  This is implementation specific.  The `workflow_type` is the type of workflow language and must be \"CWL\" or \"WDL\" currently (or another alternative supported by this WES instance).  The `workflow_type_version` is the version of the workflow language submitted and must be one supported by this WES instance.  See the `RunRequest` documentation for details about other fields. <hr>This API is broken on the Swagger-UI, when used with <i>workflow_attachment</i>. Please use the following curl instead.  curl \\  -i \\  -X POST \\  \"https://example.com/api/ga4gh/v1/runs\" \\  -H  \"accept: application/json\" \\  -H  \"Authorization: Bearer ${JWT}\" \\  -H  \"Content-Type: multipart/form-data\" \\  -F \"workflow_attachment=@/path/to/workflow.cwl\" \\  -F \"workflow_params=@/path/to/input.json;type=application/json\" \\  -F \"workflow_type=CWL\" 
         * @summary Run a workflow.
         * @param {any} [tags] tags
         * @param {Array<any>} [workflow_attachment] workflow_attachment
         * @param {any} [workflow_engine_parameters] workflow_engine_parameters
         * @param {any} [workflow_params] workflow_params
         * @param {string} [workflow_type] workflow_type
         * @param {string} [workflow_type_version] workflow_type_version
         * @param {string} [workflow_url] workflow_url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runWorkflow(tags?: any, workflow_attachment?: Array<any>, workflow_engine_parameters?: any, workflow_params?: any, workflow_type?: string, workflow_type_version?: string, workflow_url?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/ga4gh/v1/runs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (tags !== undefined) {
                localVarFormParams.set('tags', tags as any);
            }

            if (workflow_attachment) {
                workflow_attachment.forEach((element) => {
                    localVarFormParams.append('workflow_attachment', element as any);
                })
            }

            if (workflow_engine_parameters !== undefined) {
                localVarFormParams.set('workflow_engine_parameters', workflow_engine_parameters as any);
            }

            if (workflow_params !== undefined) {
                localVarFormParams.set('workflow_params', workflow_params as any);
            }

            if (workflow_type !== undefined) {
                localVarFormParams.set('workflow_type', workflow_type as any);
            }

            if (workflow_type_version !== undefined) {
                localVarFormParams.set('workflow_type_version', workflow_type_version as any);
            }

            if (workflow_url !== undefined) {
                localVarFormParams.set('workflow_url', workflow_url as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkflowExecutionServiceApi - functional programming interface
 * @export
 */
export const WorkflowExecutionServiceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel a running workflow.
         * @param {string} run_id run_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRun(run_id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RunId> {
            const localVarFetchArgs = WorkflowExecutionServiceApiFetchParamCreator(configuration).cancelRun(run_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint provides detailed information about a given workflow run. The returned result has information about the outputs produced by this workflow (if available), a log object which allows the stderr and stdout to be retrieved, a log array so stderr/stdout for individual tasks can be retrieved, and the overall state of the workflow run (e.g. RUNNING, see the State section).
         * @summary Get detailed info about a workflow run.
         * @param {string} run_id run_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunLog(run_id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RunLog> {
            const localVarFetchArgs = WorkflowExecutionServiceApiFetchParamCreator(configuration).getRunLog(run_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This provides an abbreviated (and likely fast depending on implementation) status of the running workflow, returning a simple result with the overall state of the workflow run (e.g. RUNNING, see the State section).
         * @summary Get quick status info about a workflow run.
         * @param {string} run_id run_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunStatus(run_id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RunStatus> {
            const localVarFetchArgs = WorkflowExecutionServiceApiFetchParamCreator(configuration).getRunStatus(run_id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * May include information related (but not limited to) the workflow descriptor formats, versions supported, the WES API versions supported, and information about general service availability.
         * @summary Get information about Workflow Execution Service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ServiceInfo> {
            const localVarFetchArgs = WorkflowExecutionServiceApiFetchParamCreator(configuration).getServiceInfo(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This list should be provided in a stable ordering. (The actual ordering is implementation dependent.) When paging through the list, the client should not make assumptions about live updates, but should assume the contents of the list reflect the workflow list at the moment that the first page is requested.  To monitor a specific workflow run, use GetRunStatus or GetRunLog.
         * @summary List the workflow runs.
         * @param {number} [page_size] OPTIONAL The preferred number of workflow runs to return in a page. If not provided, the implementation should use a default page size. The implementation must not return more items than &#x60;page_size&#x60;, but it may return fewer.  Clients should not assume that if fewer than &#x60;page_size&#x60; items are returned that all items have been returned.  The availability of additional pages is indicated by the value of &#x60;next_page_token&#x60; in the response.
         * @param {string} [page_token] OPTIONAL Token to use to indicate where to start getting results. If unspecified, return the first page of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRuns(page_size?: number, page_token?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RunListResponse> {
            const localVarFetchArgs = WorkflowExecutionServiceApiFetchParamCreator(configuration).listRuns(page_size, page_token, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This endpoint creates a new workflow run and returns a `RunId` to monitor its progress.  The `workflow_attachment` array may be used to upload files that are required to execute the workflow, including the primary workflow, tools imported by the workflow, other files referenced by the workflow, or files which are part of the input.  The implementation should stage these files to a temporary directory and execute the workflow from there. These parts must have a Content-Disposition header with a \"filename\" provided for each part.  Filenames may include subdirectories, but must not include references to parent directories with '..' -- implementations should guard against maliciously constructed filenames.  The `workflow_url` is either an absolute URL to a workflow file that is accessible by the WES endpoint, or a relative URL corresponding to one of the files attached using `workflow_attachment`.  The `workflow_params` JSON object specifies input parameters, such as input files.  The exact format of the JSON object depends on the conventions of the workflow language being used.  Input files should either be absolute URLs, or relative URLs corresponding to files uploaded using `workflow_attachment`.  The WES endpoint must understand and be able to access URLs supplied in the input.  This is implementation specific.  The `workflow_type` is the type of workflow language and must be \"CWL\" or \"WDL\" currently (or another alternative supported by this WES instance).  The `workflow_type_version` is the version of the workflow language submitted and must be one supported by this WES instance.  See the `RunRequest` documentation for details about other fields. <hr>This API is broken on the Swagger-UI, when used with <i>workflow_attachment</i>. Please use the following curl instead.  curl \\  -i \\  -X POST \\  \"https://example.com/api/ga4gh/v1/runs\" \\  -H  \"accept: application/json\" \\  -H  \"Authorization: Bearer ${JWT}\" \\  -H  \"Content-Type: multipart/form-data\" \\  -F \"workflow_attachment=@/path/to/workflow.cwl\" \\  -F \"workflow_params=@/path/to/input.json;type=application/json\" \\  -F \"workflow_type=CWL\" 
         * @summary Run a workflow.
         * @param {any} [tags] tags
         * @param {Array<any>} [workflow_attachment] workflow_attachment
         * @param {any} [workflow_engine_parameters] workflow_engine_parameters
         * @param {any} [workflow_params] workflow_params
         * @param {string} [workflow_type] workflow_type
         * @param {string} [workflow_type_version] workflow_type_version
         * @param {string} [workflow_url] workflow_url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runWorkflow(tags?: any, workflow_attachment?: Array<any>, workflow_engine_parameters?: any, workflow_params?: any, workflow_type?: string, workflow_type_version?: string, workflow_url?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RunId> {
            const localVarFetchArgs = WorkflowExecutionServiceApiFetchParamCreator(configuration).runWorkflow(tags, workflow_attachment, workflow_engine_parameters, workflow_params, workflow_type, workflow_type_version, workflow_url, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * WorkflowExecutionServiceApi - factory interface
 * @export
 */
export const WorkflowExecutionServiceApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Cancel a running workflow.
         * @param {string} run_id run_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRun(run_id: string, options?: any) {
            return WorkflowExecutionServiceApiFp(configuration).cancelRun(run_id, options)(fetch, basePath);
        },
        /**
         * This endpoint provides detailed information about a given workflow run. The returned result has information about the outputs produced by this workflow (if available), a log object which allows the stderr and stdout to be retrieved, a log array so stderr/stdout for individual tasks can be retrieved, and the overall state of the workflow run (e.g. RUNNING, see the State section).
         * @summary Get detailed info about a workflow run.
         * @param {string} run_id run_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunLog(run_id: string, options?: any) {
            return WorkflowExecutionServiceApiFp(configuration).getRunLog(run_id, options)(fetch, basePath);
        },
        /**
         * This provides an abbreviated (and likely fast depending on implementation) status of the running workflow, returning a simple result with the overall state of the workflow run (e.g. RUNNING, see the State section).
         * @summary Get quick status info about a workflow run.
         * @param {string} run_id run_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunStatus(run_id: string, options?: any) {
            return WorkflowExecutionServiceApiFp(configuration).getRunStatus(run_id, options)(fetch, basePath);
        },
        /**
         * May include information related (but not limited to) the workflow descriptor formats, versions supported, the WES API versions supported, and information about general service availability.
         * @summary Get information about Workflow Execution Service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceInfo(options?: any) {
            return WorkflowExecutionServiceApiFp(configuration).getServiceInfo(options)(fetch, basePath);
        },
        /**
         * This list should be provided in a stable ordering. (The actual ordering is implementation dependent.) When paging through the list, the client should not make assumptions about live updates, but should assume the contents of the list reflect the workflow list at the moment that the first page is requested.  To monitor a specific workflow run, use GetRunStatus or GetRunLog.
         * @summary List the workflow runs.
         * @param {number} [page_size] OPTIONAL The preferred number of workflow runs to return in a page. If not provided, the implementation should use a default page size. The implementation must not return more items than &#x60;page_size&#x60;, but it may return fewer.  Clients should not assume that if fewer than &#x60;page_size&#x60; items are returned that all items have been returned.  The availability of additional pages is indicated by the value of &#x60;next_page_token&#x60; in the response.
         * @param {string} [page_token] OPTIONAL Token to use to indicate where to start getting results. If unspecified, return the first page of results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRuns(page_size?: number, page_token?: string, options?: any) {
            return WorkflowExecutionServiceApiFp(configuration).listRuns(page_size, page_token, options)(fetch, basePath);
        },
        /**
         * This endpoint creates a new workflow run and returns a `RunId` to monitor its progress.  The `workflow_attachment` array may be used to upload files that are required to execute the workflow, including the primary workflow, tools imported by the workflow, other files referenced by the workflow, or files which are part of the input.  The implementation should stage these files to a temporary directory and execute the workflow from there. These parts must have a Content-Disposition header with a \"filename\" provided for each part.  Filenames may include subdirectories, but must not include references to parent directories with '..' -- implementations should guard against maliciously constructed filenames.  The `workflow_url` is either an absolute URL to a workflow file that is accessible by the WES endpoint, or a relative URL corresponding to one of the files attached using `workflow_attachment`.  The `workflow_params` JSON object specifies input parameters, such as input files.  The exact format of the JSON object depends on the conventions of the workflow language being used.  Input files should either be absolute URLs, or relative URLs corresponding to files uploaded using `workflow_attachment`.  The WES endpoint must understand and be able to access URLs supplied in the input.  This is implementation specific.  The `workflow_type` is the type of workflow language and must be \"CWL\" or \"WDL\" currently (or another alternative supported by this WES instance).  The `workflow_type_version` is the version of the workflow language submitted and must be one supported by this WES instance.  See the `RunRequest` documentation for details about other fields. <hr>This API is broken on the Swagger-UI, when used with <i>workflow_attachment</i>. Please use the following curl instead.  curl \\  -i \\  -X POST \\  \"https://example.com/api/ga4gh/v1/runs\" \\  -H  \"accept: application/json\" \\  -H  \"Authorization: Bearer ${JWT}\" \\  -H  \"Content-Type: multipart/form-data\" \\  -F \"workflow_attachment=@/path/to/workflow.cwl\" \\  -F \"workflow_params=@/path/to/input.json;type=application/json\" \\  -F \"workflow_type=CWL\" 
         * @summary Run a workflow.
         * @param {any} [tags] tags
         * @param {Array<any>} [workflow_attachment] workflow_attachment
         * @param {any} [workflow_engine_parameters] workflow_engine_parameters
         * @param {any} [workflow_params] workflow_params
         * @param {string} [workflow_type] workflow_type
         * @param {string} [workflow_type_version] workflow_type_version
         * @param {string} [workflow_url] workflow_url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runWorkflow(tags?: any, workflow_attachment?: Array<any>, workflow_engine_parameters?: any, workflow_params?: any, workflow_type?: string, workflow_type_version?: string, workflow_url?: string, options?: any) {
            return WorkflowExecutionServiceApiFp(configuration).runWorkflow(tags, workflow_attachment, workflow_engine_parameters, workflow_params, workflow_type, workflow_type_version, workflow_url, options)(fetch, basePath);
        },
    };
};

/**
 * WorkflowExecutionServiceApi - object-oriented interface
 * @export
 * @class WorkflowExecutionServiceApi
 * @extends {BaseAPI}
 */
export class WorkflowExecutionServiceApi extends BaseAPI {
    /**
     * 
     * @summary Cancel a running workflow.
     * @param {string} run_id run_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowExecutionServiceApi
     */
    public cancelRun(run_id: string, options?: any) {
        return WorkflowExecutionServiceApiFp(this.configuration).cancelRun(run_id, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint provides detailed information about a given workflow run. The returned result has information about the outputs produced by this workflow (if available), a log object which allows the stderr and stdout to be retrieved, a log array so stderr/stdout for individual tasks can be retrieved, and the overall state of the workflow run (e.g. RUNNING, see the State section).
     * @summary Get detailed info about a workflow run.
     * @param {string} run_id run_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowExecutionServiceApi
     */
    public getRunLog(run_id: string, options?: any) {
        return WorkflowExecutionServiceApiFp(this.configuration).getRunLog(run_id, options)(this.fetch, this.basePath);
    }

    /**
     * This provides an abbreviated (and likely fast depending on implementation) status of the running workflow, returning a simple result with the overall state of the workflow run (e.g. RUNNING, see the State section).
     * @summary Get quick status info about a workflow run.
     * @param {string} run_id run_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowExecutionServiceApi
     */
    public getRunStatus(run_id: string, options?: any) {
        return WorkflowExecutionServiceApiFp(this.configuration).getRunStatus(run_id, options)(this.fetch, this.basePath);
    }

    /**
     * May include information related (but not limited to) the workflow descriptor formats, versions supported, the WES API versions supported, and information about general service availability.
     * @summary Get information about Workflow Execution Service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowExecutionServiceApi
     */
    public getServiceInfo(options?: any) {
        return WorkflowExecutionServiceApiFp(this.configuration).getServiceInfo(options)(this.fetch, this.basePath);
    }

    /**
     * This list should be provided in a stable ordering. (The actual ordering is implementation dependent.) When paging through the list, the client should not make assumptions about live updates, but should assume the contents of the list reflect the workflow list at the moment that the first page is requested.  To monitor a specific workflow run, use GetRunStatus or GetRunLog.
     * @summary List the workflow runs.
     * @param {number} [page_size] OPTIONAL The preferred number of workflow runs to return in a page. If not provided, the implementation should use a default page size. The implementation must not return more items than &#x60;page_size&#x60;, but it may return fewer.  Clients should not assume that if fewer than &#x60;page_size&#x60; items are returned that all items have been returned.  The availability of additional pages is indicated by the value of &#x60;next_page_token&#x60; in the response.
     * @param {string} [page_token] OPTIONAL Token to use to indicate where to start getting results. If unspecified, return the first page of results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowExecutionServiceApi
     */
    public listRuns(page_size?: number, page_token?: string, options?: any) {
        return WorkflowExecutionServiceApiFp(this.configuration).listRuns(page_size, page_token, options)(this.fetch, this.basePath);
    }

    /**
     * This endpoint creates a new workflow run and returns a `RunId` to monitor its progress.  The `workflow_attachment` array may be used to upload files that are required to execute the workflow, including the primary workflow, tools imported by the workflow, other files referenced by the workflow, or files which are part of the input.  The implementation should stage these files to a temporary directory and execute the workflow from there. These parts must have a Content-Disposition header with a \"filename\" provided for each part.  Filenames may include subdirectories, but must not include references to parent directories with '..' -- implementations should guard against maliciously constructed filenames.  The `workflow_url` is either an absolute URL to a workflow file that is accessible by the WES endpoint, or a relative URL corresponding to one of the files attached using `workflow_attachment`.  The `workflow_params` JSON object specifies input parameters, such as input files.  The exact format of the JSON object depends on the conventions of the workflow language being used.  Input files should either be absolute URLs, or relative URLs corresponding to files uploaded using `workflow_attachment`.  The WES endpoint must understand and be able to access URLs supplied in the input.  This is implementation specific.  The `workflow_type` is the type of workflow language and must be \"CWL\" or \"WDL\" currently (or another alternative supported by this WES instance).  The `workflow_type_version` is the version of the workflow language submitted and must be one supported by this WES instance.  See the `RunRequest` documentation for details about other fields. <hr>This API is broken on the Swagger-UI, when used with <i>workflow_attachment</i>. Please use the following curl instead.  curl \\  -i \\  -X POST \\  \"https://example.com/api/ga4gh/v1/runs\" \\  -H  \"accept: application/json\" \\  -H  \"Authorization: Bearer ${JWT}\" \\  -H  \"Content-Type: multipart/form-data\" \\  -F \"workflow_attachment=@/path/to/workflow.cwl\" \\  -F \"workflow_params=@/path/to/input.json;type=application/json\" \\  -F \"workflow_type=CWL\" 
     * @summary Run a workflow.
     * @param {any} [tags] tags
     * @param {Array<any>} [workflow_attachment] workflow_attachment
     * @param {any} [workflow_engine_parameters] workflow_engine_parameters
     * @param {any} [workflow_params] workflow_params
     * @param {string} [workflow_type] workflow_type
     * @param {string} [workflow_type_version] workflow_type_version
     * @param {string} [workflow_url] workflow_url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkflowExecutionServiceApi
     */
    public runWorkflow(tags?: any, workflow_attachment?: Array<any>, workflow_engine_parameters?: any, workflow_params?: any, workflow_type?: string, workflow_type_version?: string, workflow_url?: string, options?: any) {
        return WorkflowExecutionServiceApiFp(this.configuration).runWorkflow(tags, workflow_attachment, workflow_engine_parameters, workflow_params, workflow_type, workflow_type_version, workflow_url, options)(this.fetch, this.basePath);
    }

}

